import { render, staticRenderFns } from "./matchHDPOUMAINOdds.vue?vue&type=template&id=58050d32&lang=pug&"
import script from "./matchHDPOUMAINOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUMAINOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports